import { Component, OnInit } from '@angular/core';
import { Constant, BaseComponent, DatePickerFormatter } from '../../../../../../../infrastructure/common/index';
import { OnlineOrderService } from '../../../../../../../infrastructure/services/transaction/op/outbound/order/index';


import {
  TicketService,
} from '../../../../../../../infrastructure/services/transaction/op/outbound/ticket/index';

import {
  TicketStatusService,
} from '../../../../../../../infrastructure/services/master/op/ticket-status.service'

import * as moment from 'moment';
import * as _ from 'lodash';

declare var jQuery: any;

@Component({
  selector: 'app-ticket-tracking',
  templateUrl: './ticket-tracking.component.html',
  styleUrls: ['./ticket-tracking.component.css']
})
export class TicketTrackingComponent extends BaseComponent implements OnInit {
  statuses: any[];
  accounts: any[];
  tickets: any[];
  isLoading = false;
  isStatusLoading = false;
  isAccountLoading = false;
  statusCode: string;
  bookingNo: string;
  fromETADateString: string;
  toETADateString: string;
  selectedAccount: string;

  ticketStatusCode = Constant.TicketStatusCode;

  constructor(
    private ticketService: TicketService,
    private onlineOrderService: OnlineOrderService,
    private ticketStatusService: TicketStatusService
  ) {
    super();
  }

  ngOnInit() {
    let self = this;

    let todayDateString = moment().format(self.token.DateFormatDescription.toUpperCase());
    let todayMinSevenDateString = moment().add(-7, 'day').format(self.token.DateFormatDescription.toUpperCase());

    self.statusCode = "";
    self.bookingNo = "";
    self.fromETADateString = todayMinSevenDateString;
    self.toETADateString = todayDateString;
    self.selectedAccount = "";

    

    self.loadAccounts();
    self.loadTickets(self.selectedAccount, self.statusCode,self.bookingNo, self.fromETADateString, self.toETADateString);
    self.loadTicketStatuses();
  }

  ngAfterViewInit() {
    jQuery('.frometadate-datepicker').datepicker({
      autoclose: true,
      clearBtn: true,
      format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription)
    }).on('show', (e) => {
      
    }).on('change', (e) => {
      this.fromETADateString = e.target.value;
    });

    jQuery('.toetadate-datepicker').datepicker({
      autoclose: true,
      clearBtn: true,
      format: DatePickerFormatter.mapDateFormat(this.token.DateFormatDescription)
    }).on('show', (e) => {
      // let dateDiff = 0;
      // let today = moment(new Date());
      // let fromEtaDateISOString = moment(this.fromETADateString, this.token.DateFormatDescription.toUpperCase()).toISOString();// moment("28-02-2018","dd-mm-yyyy").toISOString();
      // let fromEtaDate =  moment(new Date(fromEtaDateISOString));
      // dateDiff = fromEtaDate.diff(today, 'days')+1;

      // let startDate = dateDiff+'d';

      // jQuery('.toetadate-datepicker').datepicker('setStartDate', startDate);
    }).on('change', (e) => {
      this.toETADateString = e.target.value;
    });
  }

  showDatePicker(idEl) {
    jQuery('#' + idEl).datepicker('show');
  }

  setDefaultAccount(accounts: any[]): void {
    let self = this;

    let accountObj = _.find(accounts, function (obj) {
      return obj.OwnerCode === self.token.DefaultOwnerCode;
    });

    if(accountObj) {
      self.selectedAccount = accountObj.OwnerCode;
    }
    
  }

  filter(selectedAccount, statusCode, bookingNo, fromETADateString, toETADateString) {
    // get all status
    if (statusCode === 'undefined') {
      statusCode = '';
    }

    this.loadTickets(selectedAccount, statusCode, bookingNo, fromETADateString, toETADateString);
  }

  //load related accounts
  loadAccounts(): void {

    let self = this;
    this.isAccountLoading = true;

    const groupId = this.token.GroupId;

    this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
      .subscribe(
      data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value === Constant.MessageType.success) {
            let temp1: any[] = [];
            let temp2: any[] = [];
            
            temp1.push({Id: "OptionAll", OwnerCode: "", OwnerName: "All"});
            temp2 = message.Result
            self.accounts = temp1.concat(temp2);

            if(temp2.length <= 1) {
              self.accounts = self.accounts.filter(x => x.Id != "OptionAll");              
              self.setDefaultAccount(self.accounts);
            }
          }
          else {
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        }
        else {
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
        this.isAccountLoading = false;
      },
      error => {
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
        this.isAccountLoading = false;
      }
      );
  }

  loadTickets(ownerCode: string, statusCode: string, bookingNo: string, fromETADateString: string, toETADateString: string): void {
    let self = this;
    self.isLoading = true;

    const groupId = this.token.GroupId;

    self.ticketService.getForTracking(ownerCode, statusCode, bookingNo, fromETADateString, toETADateString, groupId)
      .subscribe(data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {
            self.tickets = message.Result;
            self.isLoading = false;
          } else {
            self.isLoading = false;
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        } else {
          self.isLoading = false;
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
      },
      error => {
        self.isLoading = false;
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      });
  }

  loadTicketStatuses(): void {
    let self = this;
    self.isStatusLoading = true;

    self.ticketStatusService.get()
      .subscribe(data => {
        let message = data;
        if (message && message.MessageType && message.MessageType.Value) {
          if (message.MessageType.Value == Constant.MessageType.success) {
            self.statuses = message.Result;
            self.isStatusLoading = false;
          } else {
            self.isStatusLoading = false;
            self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
          }
        } else {
          self.isStatusLoading = false;
          self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
        }
      },
      error => {
        self.isStatusLoading = false;
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      });
  }  

  showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''))
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/outbound/ticket/ticket-tracking/ticket-tracking.component.ts